import {ComponentClassName} from "@dp-instant/ui";
type ProgressPartProps = {x: number; progress: number; fill: string} & ComponentClassName;

export const ProgressSection = ({x, progress, fill, className}: ProgressPartProps) => {
    const width = 596;
    const height = 38;
    const strokeWidth = 4;
    const transition = "transform 0.2s";
    return (
        <g className={className}>
            <rect
                style={{
                    width,
                    height,
                    fill,
                    transform: `translateX(${width * x}px) scaleX(${progress})`,
                    transition
                }}
            />
            <rect
                style={{
                    width: strokeWidth,
                    height: height,
                    fill: "white",
                    transform: `translateX(${width * x + width * progress - strokeWidth}px)`,
                    transition
                }}
            />
        </g>
    );
};
